export const GET_METRICS = 'globalEpic/GET_METRICS';
export const GET_METRICS_SUCCESS = 'globalEpic/GET_METRICS_SUCCESS';
export const GET_METRICS_ERROR = 'globalEpic/GET_METRICS_ERROR';

export const GET_CURRENCY = 'globalEpic/GET_CURRENCY';
export const GET_CURRENCY_SUCCESS = 'globalEpic/GET_CURRENCY_SUCCESS';
export const GET_CURRENCY_ERROR = 'globalEpic/GET_CURRENCY_ERROR';
